import { useReactiveVar } from '@apollo/client';
import React, { useEffect } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { FORM_PAGES } from '../../../components/Form/types';
import FormChoice from '../../../components/FormChoice/FormChoice';
import { FORM_CHOICE_COMPONENT_TYPES, FORM_CHOICE_TYPES } from '../../../components/FormChoice/types';
import { vars } from '../../../reactive';
import { increaseFormPage } from '../../../reactive/actions';

const FormPetType = () => {
  const currentBranch = vars.currentBranch();
  const petTypes = currentBranch?.BranchTargeting?.pet_type;
  const isMoreThanOnePetType = petTypes.length > 1;
  const type = isMoreThanOnePetType ? FORM_CHOICE_TYPES.ALL_PET_TYPES : petTypes[0];
  const formOptions = useForm();
  const { control } = formOptions;
  const newPet = useReactiveVar(vars.newPet);
  const allPets = useReactiveVar(vars.allPets);

  const componentItems = {
    ...FORM_CHOICE_COMPONENT_TYPES[type],
    options: FORM_CHOICE_COMPONENT_TYPES[type].options.filter(option => petTypes.includes(option.value))
  };

  const { registerAs } = componentItems;
  const formAnswer = useWatch({ name: `choice_${registerAs}`, control });

  useEffect(() => {
    if (formAnswer) {
      vars.newPet({ ...newPet, type: formAnswer });
      increaseFormPage();
    }
  }, [formAnswer]);

  let previousPage = FORM_PAGES.PRODUCTS;

  if (vars.isFormFillView()) {
    previousPage = FORM_PAGES.FORM_SELECT;
  } else if (allPets?.length) {
    previousPage = FORM_PAGES.BOOKING_SELECT_PETS;
  }

  return (
    <FormChoice
      componentItems={componentItems}
      formOptions={formOptions}
      previousPage={{
        page: previousPage,
        animation: 'fade-out'
      }}
    />
  );
};

export default FormPetType;
